import { render } from "./PeriodSelector.vue?vue&type=template&id=d9669a1c&scoped=true"
import script from "./PeriodSelector.vue?vue&type=script&lang=ts"
export * from "./PeriodSelector.vue?vue&type=script&lang=ts"

import "./PeriodSelector.vue?vue&type=style&index=0&id=d9669a1c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d9669a1c"

export default script